import type { CurrentUser, LoginRequest, LoginResponse } from '@dsv/shared';
import { api } from './client';
import { http } from './client';
import { tokenStorage } from './token-storage';
import type { ApiSuccess, RoleCode } from '@dsv/shared';

export interface TestViewInfo {
  enabled: boolean;
  until: string | null;
  users: { id: string; username: string; displayName: string; role: RoleCode; allBrands: boolean; brandCodes: string[] }[];
}
const adminHeaders = () => ({ Authorization: `Bearer ${tokenStorage.adminAccess() ?? ''}` });
export const testViewApi = {
  async info(): Promise<TestViewInfo> {
    return (await http.get<ApiSuccess<TestViewInfo>>('/auth/test-view', { headers: adminHeaders() })).data.data;
  },
  start: (userId: string) => api.post<LoginResponse>('/auth/test-view', { userId }, { headers: adminHeaders() }),
};

export const authApi = {
  login(payload: LoginRequest): Promise<LoginResponse> {
    return api.post<LoginResponse>('/auth/login', payload);
  },
  esiStatus: () => api.get<{ enabled: boolean; available: boolean }>('/auth/esi'),
  esiLogin: () => api.post<LoginResponse>('/auth/esi', {}),

  me(): Promise<CurrentUser> {
    return api.get<CurrentUser>('/auth/me');
  },

  logout(refreshToken: string): Promise<void> {
    return api.post<void>('/auth/logout', { refreshToken });
  },

  changePassword(payload: {
    currentPassword: string;
    newPassword: string;
    confirmPassword: string;
  }): Promise<void> {
    return api.post<void>('/auth/change-password', payload);
  },
};
